import type * as Types from "../../schema.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type UpdateEmailDocumentMutationVariables = Types.Exact<{
  id: Types.Scalars["ID"];
  manualMatchRequired: Types.Scalars["Boolean"];
}>;

export type UpdateEmailDocumentMutation = {
  __typename?: "Mutation";
  updateEmailDocument: { __typename?: "MutationResult"; success: boolean };
};

export const UpdateEmailDocument = gql`
  mutation updateEmailDocument($id: ID!, $manualMatchRequired: Boolean!) {
    updateEmailDocument(id: $id, manualMatchRequired: $manualMatchRequired) {
      success
    }
  }
`;
export type UpdateEmailDocumentMutationFn = Apollo.MutationFunction<
  UpdateEmailDocumentMutation,
  UpdateEmailDocumentMutationVariables
>;

/**
 * __useUpdateEmailDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateEmailDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailDocumentMutation, { data, loading, error }] = useUpdateEmailDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      manualMatchRequired: // value for 'manualMatchRequired'
 *   },
 * });
 */
export function useUpdateEmailDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateEmailDocumentMutation,
    UpdateEmailDocumentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateEmailDocumentMutation,
    UpdateEmailDocumentMutationVariables
  >(UpdateEmailDocument, options);
}
export type UpdateEmailDocumentMutationHookResult = ReturnType<
  typeof useUpdateEmailDocumentMutation
>;
export type UpdateEmailDocumentMutationResult =
  Apollo.MutationResult<UpdateEmailDocumentMutation>;
export type UpdateEmailDocumentMutationOptions = Apollo.BaseMutationOptions<
  UpdateEmailDocumentMutation,
  UpdateEmailDocumentMutationVariables
>;
